import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DialogService } from 'src/app/core/services/dialog/dialog.service';
import { TranslationService } from 'src/app/core/services/translation/translation.service';
import { ProductDTO } from 'src/app/shared/models/dtos/responses/product-dto/product-dto';
import { maxStringLength } from 'src/app/utils/checkMaxLength';

@Component({
  selector: 'app-product-list-item',
  templateUrl: './product-list-item.component.html',
  styleUrls: ['./product-list-item.component.scss'],
})

/**
 * product list item
 */
export class ProductListItemComponent implements OnInit {
  @Input() productData!: ProductDTO;
  @Output() editProduct: EventEmitter<ProductDTO> =
    new EventEmitter<ProductDTO>();
  alt = 'printer-outline';

  /**
   * @constructor
   */
  constructor(
    private readonly dialogService: DialogService,
    private translationService: TranslationService
  ) {}

  /**
   * ng onInit
   */
  ngOnInit(): void {
    this.translationService.translateString(this.alt).then((translated) => {
      this.alt = translated;
    });
  }

  /**
   * Handles image access error on s3
   */
  handleImageError() {
    this.productData.image = '';
  }

  /**
   * Checks if admin name length is too big
   *
   * @param {string} name
   * @return {boolean}
   */
  public maxNameLength(name: string): boolean {
    return maxStringLength(name, 30);
  }

  /**
   * Shows product info modal
   */
  async openProductInfoModal() {
    this.dialogService.openProductInfoModal(this.productData, (_response) => {
      this.productData.rewardsQuantity -= 1;
    });
  }

  /**
   * Emits an event to trigger the product edit action.
   */
  goToProductEdit() {
    this.editProduct.emit(this.productData);
  }
}
